import { useId } from 'react';
import { Loader } from '@pocketlaw/tetris';
import { ScreenLayout } from '../../ScreenLayout';
import { Container } from './styled';
export function PageLoader() {
    const id = useId();
    return (<ScreenLayout.Root id={id} content={<ScreenLayout.Content>
          <Container role="status" aria-label="Loading">
            <Loader size="md"/>
          </Container>
        </ScreenLayout.Content>}/>);
}
